import { format } from '@utils/string';
import { getVendorConfigURL } from '@services/urls/apiGatewayURLs';
import cache, { KEYS, TTLS } from '@services/cache';
import { isNullOrUndefined } from '@utils/object';
import ServiceResponse from '../models/ServiceResponse';

async function getHideNotes({ axios, id }) {
  try {
    if (!id) return new ServiceResponse({ error: 'id param is required' });

    const key = `${KEYS.VENDOR_CONFIG_NOTES}_${id}`;
    const dataFromCache = cache.get(key);

    if (isNullOrUndefined(dataFromCache)) {
      const response = await axios.get(format(getVendorConfigURL, id));

      const hideNotes = Boolean(response?.data?.hide_notes);

      cache.set(key, hideNotes, {
        ttl: TTLS.VENDOR_CONFIG_NOTES,
      });

      return new ServiceResponse({ data: hideNotes });
    }

    return new ServiceResponse({ data: dataFromCache });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default getHideNotes;
